/**
 * Original solution comes from Microsoft. See link below:
 * @link https://github.com/microsoft/vscode/blob/f5738efe91cb1d0089d3605a318d693e26e5d15c/extensions/markdown-language-features/src/slugify.ts#L22-L29
 **/
export const slugify = (text: string) =>
  encodeURI(
    text
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace whitespace with -
      .replace(
        /[\][!'#$%&'()*+,./:;<=>?@\\^_{|}~`。，、；：？！…—·ˉ¨‘’“”々～‖∶＂＇｀｜〃〔〕〈〉《》「」『』．〖〗【】（）［］｛｝]/g,
        ''
      ) // Remove known punctuators
      .replace(/^-+/, '') // Remove leading -
      .replace(/-+$/, '') // Remove trailing -
  );
